import { render, staticRenderFns } from "./AlphabetSystemMemoView.vue?vue&type=template&id=2e0faa8e&scoped=true&"
import script from "./AlphabetSystemMemoView.vue?vue&type=script&lang=js&"
export * from "./AlphabetSystemMemoView.vue?vue&type=script&lang=js&"
import style0 from "./AlphabetSystemMemoView.vue?vue&type=style&index=0&id=2e0faa8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0faa8e",
  null
  
)

export default component.exports